import React, { useState, useEffect } from 'react';
import './Header.css';

const NAV = [
  { key: 'home',      label: 'Beranda' },
  { key: 'diagnosis', label: 'Diagnosis' },
  { key: 'about',     label: 'Tentang Model' },
];

export default function Header({ page, go }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 16);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  const nav = (key) => { go(key); setOpen(false); };

  return (
    <header className={`hdr${scrolled ? ' scrolled' : ''}`}>
      <div className="hdr-inner">
        {/* Logo */}
        <button className="logo" onClick={() => nav('home')}>
          <svg width="28" height="28" viewBox="0 0 32 32" fill="none">
            <path d="M6 24 L6 8 L16 22 L16 8" stroke="#0a0a0a" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="24" cy="22" r="3" fill="#0a0a0a"/>
          </svg>
          <span>Neura<span className="logo-hi">Scan</span></span>
        </button>

        {/* Desktop nav */}
        <nav className={`nav${open ? ' open' : ''}`}>
          {NAV.map(n => (
            <button
              key={n.key}
              className={`nav-link${page === n.key ? ' active' : ''}`}
              data-no-chevron
              onClick={() => nav(n.key)}
            >
              {n.label}
            </button>
          ))}
          {/* CTA duplikat khusus mobile — tampil di dalam drawer */}
          <button className="nav-cta-mobile" onClick={() => nav('diagnosis')}>
            Mulai Diagnosis
          </button>
        </nav>

        {/* CTA */}
        <button className="nav-cta" onClick={() => nav('diagnosis')}>Mulai Diagnosis</button>

        {/* Hamburger */}
        <button className={`burger${open ? ' open' : ''}`} onClick={() => setOpen(v => !v)} aria-label="Menu">
          <span/><span/><span/>
        </button>
      </div>
    </header>
  );
}
